import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	enableFinancingServices: true,
	enablePartsRateCalculation: false,
	financeDomain: 'AUDI.CC.IT',
	nextBestActions: [
		{
			description: 'Ricerca un dealer',
			icon: '',
			labelText: 'Ricerca un dealer',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://www.audi.it/it/web/it/rete-audi.html',
		},
		{
			description: 'Ricerca auto nuove ',
			icon: 'used-cars',
			labelText: 'Ricerca auto nuove ',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.it/it/web/it/ricerca-auto-nuove.html#filter=carline.{{carlineId}}',
		},
	],
	summaryFooterCta: {
		description: 'Richiesta preventivo',
		icon: 'test-drive',
		labelText: 'Richiesta preventivo',
		target: '_blank',

		trackingName: 'testdrive',
		url: 'https://testdrive.audi.it/audiconfigurator/configurator_code:{{audiCode}}',
	},
};
